import { z } from 'zod';
import { graphCountSchema, graphIdSchema } from './primitives';

export const nativeCaptureRectSchema = z.object({ x: z.number().finite().nonnegative(), y: z.number().finite().nonnegative(),
  width: z.number().finite().positive(), height: z.number().finite().positive() }).strict();
export const nativeObservationGeometrySchema = z.object({ width: graphCountSchema.refine(value => value > 0),
  height: graphCountSchema.refine(value => value > 0),
  regions: z.array(z.object({ regionId: graphIdSchema, rect: nativeCaptureRectSchema }).strict()) }).strict()
  .superRefine((geometry, context) => {
    if (new Set(geometry.regions.map(region => region.regionId)).size !== geometry.regions.length
      || geometry.regions.some(({ rect }) => rect.x + rect.width > geometry.width || rect.y + rect.height > geometry.height)) context.addIssue({
      code: z.ZodIssueCode.custom, message: 'Native matching rectangles must be unique and inside the actual capture frame' });
  });
export type NativeObservationGeometry = z.infer<typeof nativeObservationGeometrySchema>;
